// @flow

import * as React from 'react';

import Emojify from 'app/components/shared/Emojify';
import BlockFieldsModal, { type Field } from 'app/components/job/BlockFieldsModal';

export type ManualStepType = {
  type: 'manual',
  id: string,
  activatePath: string,
  fields: Array<Field>,
  name: ?string,
  permissions: {
    activate: {
      allowed: boolean,
      message?: string
    }
  },
  step?: {
    label: ?string
  },
  prompt: ?string,
  state: string,
  submit: ?string,
  tooltip?: string,
  triggerProject?: {
    name: string
  },
  unblockedAt?: string
};

type Props = {
  job: ManualStepType,
  stepClassName: string
};

type State = {
  fieldsModalActivated: boolean
};

export default class ManualStep extends React.Component<Props, State> {
  fieldsModal: ?BlockFieldsModal;

  state = {
    fieldsModalActivated: false
  };

  componentDidUpdate(prevProps: Props, prevState: State) {
    if (prevState.fieldsModalActivated !== this.state.fieldsModalActivated && this.fieldsModal) {
      this.fieldsModal.show();
    }
  }

  render() {
    const fieldsModal = this.state.fieldsModalActivated && (
      <BlockFieldsModal
        ref={(fieldsModal) => this.fieldsModal = fieldsModal}
        job={this.props.job}
      />
    );

    return (
      <div
        key={this.props.job.id}
        className="inline-block build-pipeline-job__wrapper"
      >
        {fieldsModal}
        {this.renderStep()}
      </div>
    );
  }

  renderStep() {
    if (this.props.job.state === "broken") {
      return (
        <div
          data-tooltip-length="medium"
          aria-label={this.props.job.tooltip}
          className={this.props.stepClassName}
        >
          <span className="build-pipeline-job__icon">
            <i className="fa fa-lock" />
          </span>
          {this.nameNode()}
        </div>
      );
    } else if (!this.props.job.permissions.activate.allowed) {
      return (
        <div
          aria-label={this.props.job.permissions.activate.message}
          className={this.props.stepClassName}
        >
          <span className="build-pipeline-job__icon">
            <i className="fa fa-lock" />
          </span>
          {this.nameNode()}
        </div>
      );
    } else if (this.props.job.unblockedAt) {
      return (
        <div className={this.props.stepClassName}>
          <span className="build-pipeline-job__icon">
            <i className="fa fa-chevron-right" />
          </span>
          {this.nameNode()}
        </div>
      );
    } else if ((this.props.job.state === "skipped") || (this.props.job.state === "canceled") || (this.props.job.state === "blocked_failed")) {
      return (
        <div className={this.props.stepClassName}>
          <span className="build-pipeline-job__icon">
            <i className="fa fa-lock" />
          </span>
          {this.nameNode()}
        </div>
      );
    }
    if (this.props.job.fields) {
      return (
        <a
          href="#"
          onClick={this.handleContinueButtonClick}
          className={this.props.stepClassName}
        >
          <span className="build-pipeline-job__icon">
            <i className="fa fa-lock" />
          </span>
          {this.nameNode()}
        </a>
      );
    }

    return (
      <a
        href={this.props.job.activatePath}
        data-remote="true"
        data-confirm={this.props.job.prompt || "Unblock this step?"}
        data-method="post"
        className={this.props.stepClassName}
      >
        <span className="build-pipeline-job__icon">
          <i className="fa fa-lock" />
        </span>
        {this.nameNode()}
      </a>
    );
  }

  handleContinueButtonClick = (evt: SyntheticMouseEvent<HTMLAnchorElement>) => {
    evt.preventDefault();

    if (this.state.fieldsModalActivated && this.fieldsModal) {
      return this.fieldsModal.show();
    }

    this.setState({ fieldsModalActivated: true });
  };

  nameNode() {
    return (
      <span className="build-pipeline-job__name">
        <Emojify text={this.props.job.name || "Continue"} />
      </span>
    );
  }
}
